<app-nav-pages></app-nav-pages>

<main>
  <section class="hero-section d-flex justify-content-center align-items-center csr-hero">
    <div class="overlay"></div>
    <div class="hero-text d-flex align-items-center justify-content-center  text-center  flex-column ">
      <h3 #textContent>INNOVATION</h3>
      <h2 #textContent>THE HIGHEST STANDARD</h2>

    </div>
  </section>
  
  
  <section class="brand-wrapper py-5 mt-5">
    <div class="brand_container py-3 d-flex gap-3 f-c ">
      <div class="statement wo-100">
        <h2 #leftReveal>The Pursuit Of Value Creation.</h2>
      </div>
      <div class="brand-text wo-100" #rightReveal>
        <p>
          ZUMERA Guiding Philosphy lies in a Long-Term Vision of creating innovative experiences that improve the lives of people and transform communities.
        </p>
        <p>Building an Inspired and Sustainable Future for African Communities reenforces ZUMERA’S Ethos of Innovation, The Highest Standard and the Best Value.</p>
  
      </div>
    </div>
  </section>
  
  <section class="container create-value text-center" #textContent>
    <h2>Creating Value, transforming Communities</h2>
    <p>Zumera Property is a world-class real estate company that is committed to building revolutionary structures and infrastructures, that open up communities to opportunities.  By applying the concept of innovative thinking to all we do, we create distinction through our unique UVP. Our specialization include Property Development, Investment and Management.</p>
  </section>

  <!-- <section class="container ">
    <div class="d-flex align-items-center p-5 justify-content-between  property-item">
      <div class="property-text">
        <p class="section_tag ">PROPERTY DEVELOPMENT</p>
      <h2>We build to create value</h2>
      <p>At Zumera, we build properties differently from other developers. We don’t just build to build, we build to create value for investors and make a difference in the areas where our projects are located. We are focused on creating exceptional structures that can compare with some of the best in the world. Value creation is at the heart of everything we do.</p>
      <p>Our current projects include The Zumera Tower, The Elite Residences, Queen Idia Residence and Zumera Elite Lands.</p>
      </div>
      
      <div class="property-imgs">
        <img src="assets/imgs/property-img-1.jpg" class="img-fluid" alt="">
      </div>      
    </div>

    <div class="d-flex align-items-center p-5 justify-content-between property-item second-child">
      <div class="property-imgs">
        <img src="assets/imgs/property-img-2.jpg" class="img-fluid " alt="">
      </div>
      <div class="property-text">
        <p class="section_tag ">PROPERTY MANAGEMENT</p>
        <h2>Great Properties thrive on great
          maintenace culture</h2>
          <p>One of the areas in which we excel is in Property Management, and this is fundamentally because we operate a mantra that a property is as good as the quality of maintenance and management it is constantly exposed to. </p>
          <p>For us at Zumera, our commitment to quality management is second to none. We have put together some of the best professionals in building management to oversee all of our projects and also extend to other structures that need professional management.</p>
      </div>      
    </div>

    <div class="d-flex align-items-center p-5 justify-content-between property-item ">
      <div class="property-text  ">
        <p class="section_tag ">PROPERTY INVESTMENT</p>
        <h2>Highest ROI, greatest value, least risk</h2>

        <p>Our Property Investment service is hinged on the concept of creating wealth together because real estate provides the highest returns, the greatest values and the least risk ever.</p>
        <p>Our property investment service caters to the needs of savvy and long or short term investors, who understand the numerous opportunities of real estate investment and are willing to either invest in owning a property, or invest for a short-term period of 1 to 2 years and earn up to 60% ROI.</p>
      </div>
      
      <div class="property-imgs ">
        <img src="assets/imgs/property-img-3.jpg" class="img-fluid " alt="">
      </div>
    </div>
  </section> -->
</main>


<div class="my-5  d-flex flex-column ">
  <p class="quote_3_p text-center">NEXT <span class="rdj_bold">&#8594;</span></p>
  <h3 class="mb-3 text-center rdj_bold"> JOIN THE ZUMERA TRIBE </h3>
  <a routerLink="/join-our-tribe" class="know-more-btn align-self-center ">KNOW MORE</a>
</div>

<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm  class="w-100 d-sm-none"></app-footer-sm>